<template>
  <v-container fluid>
    <v-row justify="space-between" no-gutters align="center">
      <v-col cols="12" md="5">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1">Oportunidades em aberto</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <totalizador-aberto></totalizador-aberto>
    <v-tabs
      next-icon="chevron_right"
      prev-icon="chevron_left"
      show-arrows
      class="ui-tabs"
      v-model="tabs">
      <v-tab link to="#oportunidades">
        <v-icon>handshake</v-icon> Oportunidades
      </v-tab>
      <v-tab link to="#kanban-fotovoltaico" v-if="$root.Permissions.integrator()">
        <v-icon>view_kanban</v-icon> Kanban fotovoltaico
      </v-tab>
      <v-tab link to="#funil-fotovoltaico" v-if="$root.Permissions.integrator()">
        <v-icon>filter_alt</v-icon> Funil fotovoltaico
      </v-tab>
      <v-tab link to="#relatorios">
        <v-icon>assessment</v-icon> Relatórios
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item class="px-1 pb-1" id="oportunidades">
        <lista-oportunidades :status="1"></lista-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1" id="kanban-fotovoltaico">
        <kanban-oportunidades :status="1"></kanban-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1" id="funil-fotovoltaico">
        <funil-oportunidades :status="1"></funil-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-4 pb-1" id="relatorios">
        <relatorio-oportunidades :status="1"></relatorio-oportunidades>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import TotalizadorAberto from './TotalizadorAberto.vue'
import FunilOportunidades from '../FunilOportunidades.vue'
import ListaOportunidades from '../ListaOportunidades.vue'
import KanbanOportunidades from '../KanbanOportunidades.vue'
import RelatorioOportunidades from '../RelatorioOportunidades.vue'

export default {
  components: {
    TotalizadorAberto,
    ListaOportunidades,
    KanbanOportunidades,
    FunilOportunidades,
    RelatorioOportunidades
  },
  data () {
    return {
      tabs: 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>>.v-tabs-items {
  min-height: calc(100vh - 200px)!important;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/abertas/Abertas.vue